export enum MessageRole {
  USER = "user",
  ASSISTANT = "assistant",
}

export interface SourceReference {
  document_id: string;
  document_name: string;
  content_preview: string;
  page?: number;
  relevance: number;
}

export interface ChatMessage {
  id: string;
  role: MessageRole;
  content: string;
  sources: SourceReference[];
  created_at: string;
}

export interface ChatSession {
  id: string;
  titulo: string;
  licitacion_id?: string;
  message_count: number;
  created_at: string;
  updated_at: string;
}

export interface ChatSessionDetail {
  id: string;
  titulo: string;
  licitacion_id?: string;
  messages: ChatMessage[];
  created_at: string;
  updated_at: string;
}

// Mejora "Asistente con ámbito": el chat acota el RAG a bases (pliego)
// o apoyo (empresa). Si no se manda, busca en todo.
export type ChatFamilia = "bases" | "apoyo";

export interface ChatMessageRequest {
  message: string;
  session_id?: string;
  licitacion_id?: string;
  document_ids?: string[];
  familia?: ChatFamilia;
}

export interface ChatResponse {
  session_id: string;
  message: ChatMessage;
}

export interface CreateSessionRequest {
  licitacion_id?: string;
  titulo?: string;
}
